import { render, staticRenderFns } from "./TopicDistributions.vue?vue&type=template&id=6e9736c1&scoped=true&"
import script from "./TopicDistributions.vue?vue&type=script&lang=js&"
export * from "./TopicDistributions.vue?vue&type=script&lang=js&"
import style0 from "./TopicDistributions.vue?vue&type=style&index=0&id=6e9736c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9736c1",
  null
  
)

export default component.exports